<template>
  <div class="main">
    <c-panel title="Seções da biblioteca" titleIcon="fas fa-boxes">
      <!--
        Item 5 do edital, literal: "cadastrar as seções, permitindo informar a biblioteca,
        conforme cadastro de bibliotecas, a descrição e a colocação, com as opções: armário,
        prateleira, ou outro, além da colocação inicial, final e localização."
      -->
      <el-row :gutter="10" class="u-mt-10 u-mb-20">
        <el-col :xs="24" :sm="8">
          <el-input v-model="filtro.termo" placeholder="Pesquisar por descrição" clearable
                    @keyup.native.enter="load" @clear="load"></el-input>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-select v-model="filtro.biblioteca_id" placeholder="Biblioteca" clearable
                     @change="load" style="width:100%" filterable>
            <el-option v-for="b in bibliotecas" :key="b.id" :label="b.nome" :value="b.id"></el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="8" class="u-text-right">
          <el-button class="u-mr-10" @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
          <el-button v-if="podeEscrever" type="primary" icon="el-icon-plus" @click="abrirNovo"
                     :disabled="bibliotecas.length === 0">NOVA SEÇÃO</el-button>
        </el-col>
      </el-row>

      <el-alert v-if="bibliotecas.length === 0 && statusList" type="info" show-icon :closable="false"
                class="u-mb-15" title="Nenhuma biblioteca cadastrada no seu escopo"
                description="A seção pertence a uma biblioteca. Cadastre a biblioteca primeiro."></el-alert>

      <div class="container-table">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="hidden-mobile" style="width:70px;">cod</th>
              <th>Descrição</th>
              <th class="hidden-mobile">Biblioteca</th>
              <th style="width:120px;">Colocação</th>
              <th class="hidden-mobile" style="width:150px;">Inicial / Final</th>
              <th class="hidden-mobile" style="width:160px;">Localização</th>
              <th class="hidden-mobile u-text-center" style="width:80px;">Ativa</th>
              <th style="width:130px;" class="u-text-center" v-if="podeEscrever">Ação</th>
            </tr>
          </thead>
          <tbody v-if="statusList">
            <tr v-for="s in items" :key="s.id">
              <td class="hidden-mobile">{{ s.id }}</td>
              <td>{{ s.descricao }}</td>
              <td class="hidden-mobile">{{ s.biblioteca_nome || '—' }}</td>
              <td>{{ rotuloColocacao(s.colocacao) }}</td>
              <td class="hidden-mobile">{{ (s.colocacao_inicial || '—') + ' / ' + (s.colocacao_final || '—') }}</td>
              <td class="hidden-mobile">{{ s.localizacao || '—' }}</td>
              <td class="hidden-mobile u-text-center">{{ s.situacao ? 'SIM' : 'NÃO' }}</td>
              <td class="u-text-center acao" v-if="podeEscrever">
                <el-button @click="abrirEdicao(s)" title="Editar" type="info" icon="el-icon-edit"
                           size="mini" plain class="u-mr-10"></el-button>
                <el-button @click="excluir(s)" title="Excluir" type="danger" icon="el-icon-delete"
                           size="mini" plain></el-button>
              </td>
            </tr>
            <tr v-if="items.length === 0">
              <td :colspan="podeEscrever ? 8 : 7" class="u-text-center">Nenhuma seção encontrada.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <el-dialog :title="editandoId ? 'Editar seção' : 'Nova seção'" :visible.sync="dialogAberto"
                 width="640px" append-to-body>
        <el-form :model="form" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12">
              <el-form-item label="Biblioteca *">
                <el-select v-model="form.biblioteca_id" placeholder="Biblioteca" style="width:100%" filterable>
                  <el-option v-for="b in bibliotecas" :key="b.id" :label="b.nome" :value="b.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="Descrição *"><el-input v-model="form.descricao" maxlength="191"></el-input></el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item label="Colocação *">
                <el-select v-model="form.colocacao" placeholder="Colocação" style="width:100%">
                  <el-option v-for="c in colocacoes" :key="c.valor" :label="c.rotulo" :value="c.valor"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item label="Colocação inicial"><el-input v-model="form.colocacao_inicial" maxlength="40"></el-input></el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item label="Colocação final"><el-input v-model="form.colocacao_final" maxlength="40"></el-input></el-form-item>
            </el-col>
            <el-col :xs="24" :sm="16">
              <el-form-item label="Localização"><el-input v-model="form.localizacao" maxlength="191"></el-input></el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item label="Ativa"><el-switch v-model="form.situacao"></el-switch></el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogAberto = false">CANCELAR</el-button>
          <el-button class="u-ml-10" type="primary" @click="salvar" :loading="salvando">SALVAR</el-button>
        </span>
      </el-dialog>
    </c-panel>
  </div>
</template>

<script>
const COLOCACOES = [
  { valor: 'armario', rotulo: 'Armário' },
  { valor: 'prateleira', rotulo: 'Prateleira' },
  { valor: 'outro', rotulo: 'Outro' }
]

export default {
  components: { cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    statusList: false,
    items: [],
    bibliotecas: [],
    colocacoes: COLOCACOES,
    filtro: { termo: '', biblioteca_id: '' },
    dialogAberto: false,
    salvando: false,
    editandoId: null,
    form: {}
  }),
  computed: {
    podeEscrever () { return [1, 4, 5, 12].indexOf(Number(this.$store.state.user.tipo)) !== -1 },
    base () { return `${this.$store.state.config.baseUrlApi}/api/biblioteca/secao` }
  },
  mounted () { this.carregarBibliotecas(); this.load() },
  methods: {
    rotuloColocacao (v) {
      const c = COLOCACOES.filter(x => x.valor === v)[0]
      return c ? c.rotulo : (v || '—')
    },
    carregarBibliotecas () {
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/unidade/getAllPaginate`,
                       { per_page: 200 }, this.$store.getters.getHeaderAuth)
        .then(r => { this.bibliotecas = (r.data && !r.data.erro) ? (r.data.data || []) : [] })
        .catch(() => { this.bibliotecas = [] })
    },
    load () {
      this.statusList = false
      this.$axios.post(`${this.base}/getAllPaginate`, this.filtro, this.$store.getters.getHeaderAuth)
        .then(r => {
          if (r.data && r.data.erro) {
            this.statusList = true
            return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          }
          this.items = r.data.data || []
          this.statusList = true
        }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
    },
    abrirNovo () {
      this.editandoId = null
      this.form = { biblioteca_id: '', descricao: '', colocacao: '', colocacao_inicial: '',
                    colocacao_final: '', localizacao: '', situacao: true }
      this.dialogAberto = true
    },
    abrirEdicao (s) {
      this.editandoId = s.id
      this.form = {
        biblioteca_id: s.biblioteca_id, descricao: s.descricao, colocacao: s.colocacao,
        colocacao_inicial: s.colocacao_inicial || '', colocacao_final: s.colocacao_final || '',
        localizacao: s.localizacao || '', situacao: !!s.situacao
      }
      this.dialogAberto = true
    },
    salvar () {
      if (!this.form.biblioteca_id || !this.form.descricao || !this.form.colocacao) {
        return window.eventBus.$emit('alert', { msg: 'Informe a biblioteca, a descrição e a colocação.', type: 'warning' })
      }
      this.salvando = true
      const url = this.editandoId ? `${this.base}/update/${this.editandoId}` : `${this.base}/store`
      this.$axios.post(url, this.form, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.salvando = false
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          this.dialogAberto = false
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.load()
        }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
    },
    excluir (s) {
      this.$msgbox.confirm('Tem certeza que deseja excluir esta seção?', 'Atenção',
        { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          this.$axios.delete(`${this.base}/delete/${s.id}`, this.$store.getters.getHeaderAuth)
            .then(r => {
              if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.load()
            }).catch(e => this.$store.commit('throwException', e))
        }).catch(() => {})
    }
  }
}
</script>
